console.log('custom.js');

/*
Collections フィルターのz-indexバグを修正
*/
$('[data-mobile-filters-toggle]').click(function(){
  $('.collection--has-filter-bar').addClass('is-active');
});
$('.filter-drawer__wash').click(function(){
  $('.collection--has-filter-bar').removeClass('is-active');
});

/*
検索: クリアボタン
*/
$('.js-searchform-input').on('keyup', function() {
  showClearBtn($(this));
});
$('.js-searchform-input').on('change', function() {
  showClearBtn($(this));
});
function showClearBtn($this){
  if($this != ''){
    $('.js-searchform-clear').fadeIn(300);
  }else{
    $('.js-searchform-clear').fadeOut(300);
  }
}
$('.js-searchform-clear').click(function(){
  $('.js-searchform-input').val('');
  $('.js-searchform-clear').fadeOut(300);
});

/*
1：ヘッダー固定サーチエリア
*/
if($('.js-custom-headersearch').length){
  $('input.search-form__input').focus(function(){
    $('.js-headersearch-keyword').slideDown();
  });
  $(document).click(function(e) {
    if(!$(e.target).closest('.js-custom-headersearch').length) {
      $('.js-headersearch-keyword').slideUp();
    } 
  });
}

/*
3：バッジ通知
*/
$('.js-notification-open').click(function(){
  $('.js-notification').toggle();
});
$('.js-notification-btn>button:first-child').addClass('is-active');
$('.js-notification-btn>button').click(function(){
  tab = $(this).data('tab');
  $('.js-notification-btn>button').removeClass('is-active');
  $(this).addClass('is-active');
  $('.js-notification-tab').css('display','none');
  $('.js-notification-tab[data-tab="'+ tab +'"]').css('display','block');
});
/* 
13：SKUカート
*/
var skucart_scrollY = 0;
$('.js-skucart-open').on('click', function(e){
  skucart_scrollY = window.scrollY;
  console.log(skucart_scrollY);
  e.preventDefault();
  $('body').addClass('is-skucart-open');
  $('html,body').scrollTop(skucart_scrollY);
  $(this).next('.js-skucart-wrap').css('display', 'flex');
});
$('.js-skucart-close').on('click', function(){
  $('body').removeClass('is-skucart-open');
  $('html,body').scrollTop(skucart_scrollY);
  $('.js-skucart-wrap').css('display', 'none');
});/* 
13：人気キーワード
検索ボックス入力中はクイック検索結果が表示されるため、人気キーワードは非表示とする。
*/
var $keywordslist = $('.js-keywordslist');
$('input.quick-search__input').keyup(function(){ //検索ボックス入力時
  if($('.quick-search__bar-inner').hasClass('active')){ //入力時にactiveクラスがついたら非表示
    $keywordslist.css('display','none');
  }else{
    $keywordslist.css('display','block');
  }
});/*
14：送料無料
クイックカート内の数量変更を検知して、「あと**円」の表記を更新する。
*/
var freeshipping_price = $('.js-freeshipping-body').data('freeshipping-price');
$('.js-freeshipping-changeTrigger').on('DOMSubtreeModified propertychange', function() {
  changeFreeshipping();
});
function changeFreeshipping(){
  fetch('/cart.js')
  .then(response => response.json())
  .then(data => {
    console.log('DATA');
    console.log(data);
    if(data.total_price < freeshipping_price){
      $('.js-freeshipping-body').attr('data-freeshipping','false');
      result = (freeshipping_price - data.total_price)/100;
      $('.js-freeshipping-val').html('&yen'+result.toLocaleString());
      $('.js-freeshipping-link').attr('href','/collections/all?sort_by=price-ascending&amp;filter.v.price.lte='+result);
    }else{
      $('.js-freeshipping-body').attr('data-freeshipping','true');
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}